import styled from 'styled-components';

/* ----------------------------------
   Feature strip
----------------------------------- */

export const FeatureStrip = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  border-top: 1px solid var(--grey);
  border-bottom: 1px solid var(--grey);

  @media screen and (max-width: 1050px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureStripItem = styled.div`
  padding: var(--space-xl) var(--space-l);

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  position: relative;

  &:not(:last-child)::after {
    content: '';

    position: absolute;
    top: 22%;
    right: 0;

    width: 1px;
    height: 56%;

    background: var(--grey);
  }

  strong {
    display: block;

    margin-bottom: var(--space-xxs);

    color: var(--grey7);

    font-size: 0.9rem;
    font-weight: 900;
  }

  span {
    color: var(--grey4);

    font-size: 0.8rem;
    line-height: 1.5;
  }

  @media screen and (max-width: 1050px) {
    &:nth-child(2)::after {
      display: none;
    }

    &:nth-child(-n + 2) {
      border-bottom: 1px solid var(--grey);
    }
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l) var(--space-xs);

    &:not(:last-child) {
      border-bottom: 1px solid var(--grey);
    }

    &::after {
      display: none;
    }
  }
`;

export const FeatureStripIcon = styled.div`
  width: 38px;
  height: 38px;

  flex-shrink: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--yellow1);
  color: var(--orange5);

  font-size: 0.95rem;
`;
